export const INITIAL_VARIETIES_REQUEST = "INITIAL_VARIETIES_REQUEST";
export const FETCH_VARIETIES_SUCCESS = "FETCH_VARIETIES_SUCCESS";
export const FINAL_VARIETIES_REQUEST = "FINAL_VARIETIES_REQUEST";
